import {useSetAtom} from "jotai";
import {UploadedAtom} from "./useUpload.ts";
import {useQueryClient} from "@tanstack/react-query";

export function useClearUpload(): ()=>Promise<void> {
    const client = useQueryClient()
    const upload = useSetAtom(UploadedAtom)
    return async () => {
        try {
            await client.invalidateQueries({
                queryKey: ["upload-token"]
            })
            upload("idle")
        } catch(e) {
            console.error("Error clearing upload state", e)
        }
    }
}